export default __webpack_public_path__ + "static/media/eventbeep.19822fc9.png";